import React, { useEffect } from "react";
import {
  Styles,
  slideOnAnimationBottom,
  slideOnAnimationTop,
  slideOnAnimationBottomCenter,
  slideOnAnimationTopCenter
} from "./Toast.styles";
import { CloseButton, CloseIcon } from "./CloseButton.styles";
import { Text, BodyText, LinkText, TextContainer } from "./Text.styles";
import { AlertIcon } from "../AlertIcon";
const Toast = ({
  severity = "info",
  message,
  label,
  body,
  link,
  position = "bottom-right",
  lifetime = 5e3,
  showClose = true,
  closeCallback = () => {
  },
  className,
  animationClass = ""
}) => {
  useEffect(() => {
    let timer;
    if (lifetime !== 0) {
      timer = setTimeout(closeCallback, lifetime);
    }
    return () => clearTimeout(timer);
  });
  const getClassNames = () => {
    const classes = [className, animationClass, `position--${position}`];
    if (position.includes("top-center")) {
      classes.push(slideOnAnimationTopCenter);
    } else if (position.includes("bottom-center")) {
      classes.push(slideOnAnimationBottomCenter);
    } else if (position.includes("bottom")) {
      classes.push(slideOnAnimationBottom);
    } else {
      classes.push(slideOnAnimationTop);
    }
    return classes.join(" ");
  };
  return /* @__PURE__ */ React.createElement(Styles, {
    role: "alert",
    className: getClassNames()
  }, /* @__PURE__ */ React.createElement(AlertIcon, {
    className: "toast-icon",
    level: severity
  }), /* @__PURE__ */ React.createElement(TextContainer, null, /* @__PURE__ */ React.createElement(Text, {
    className: "toast-text"
  }, message || label), /* @__PURE__ */ React.createElement(BodyText, {
    className: "toast-text"
  }, body), link && /* @__PURE__ */ React.createElement(LinkText, {
    className: "toast-text",
    href: link?.href
  }, link?.text)), showClose && /* @__PURE__ */ React.createElement(CloseButton, {
    onClick: closeCallback
  }, /* @__PURE__ */ React.createElement(CloseIcon, {
    className: "toast-close-icon"
  })));
};
export default Toast;
